import { useSelector } from 'react-redux';

import { getCartTitle } from 'common/helpers/miscHelpers';
import { getCheckoutHref, getCartHref } from 'common/helpers/routerHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const Proceed = () => {
  const { t } = useLocalization();
  const cart = useSelector((state) => state.cart.data);
  const settings = useSelector((state) => state.setting.data);

  return (
    <>
      <div className="c7-order-summary__buttons">
        <a href={getCartHref('')} className="c7-btn c7-btn--alt">
          {t('checkout.general.viewCart', {
            cartTitle: getCartTitle(settings, t)
          })}
        </a>
        {cart.errors.length === 0 && (
          <a
            href={getCheckoutHref('/cart')}
            className="c7-btn c7-btn--primary"
            id="c7-side-cart__summary__proceed"
            data-testid="proceed-to-checkout-link"
          >
            {t('checkout.general.proceedToCheckout')}
          </a>
        )}
      </div>
    </>
  );
};

export default Proceed;
